export default __webpack_public_path__ + "static/media/BannersW_PROMO_DIADELASMADRES_GMM_330x330.275f3535.png";